/**
 * Strips query string and hash so a menu path can be compared to the router's
 * `asPath`.
 */
const stripPath = (asPath: string) => {
  const queryIndex = asPath.search(/[?#]/);

  return queryIndex === -1 ? asPath : asPath.slice(0, queryIndex);
};

/**
 * Picks the single menu path that is active for the current URL.
 *
 * "/account/settings" is a prefix of "/account/settings/payment", so a plain
 * `startsWith` lights up Accountinstellingen and Betaalinstellingen at the same
 * time. The longest matching path wins instead, and a path only matches at a
 * segment boundary ("/account/ads" must not match "/account/ads-archive").
 */
export const getActiveAccountMenuPath = (
  asPath: string,
  paths: string[]
): string | undefined => {
  const current = stripPath(asPath);

  return paths
    .filter(path => current === path || current.startsWith(`${path}/`))
    .sort((left, right) => right.length - left.length)[0];
};
